import { Visibility } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogContent, DialogTitle, Grid, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useTranslate } from 'react-admin'
import { ShowCard } from 'src/components/uiElements/cards/ShowCard'
import { accountServices } from 'src/services/payment/account/account.service'
import RefreshIcon from '@mui/icons-material/Refresh';
import { parseDateFormat } from 'src/helper/parseDateFormat'
import { numberFormatterWithDecimalAndThousand } from 'src/helper/numberFormatterWithDecimalAndThousand'

export const BalanceTransfer = ({hash_reservation, currentNumber}) => {
    const translate = useTranslate()
    const [receivedTransfer, setReceivedTransfer] = useState([])
    const [sentTransfer, setSentTransfer] = useState([])
    const [receivedLoading, setReceivedLoading] = useState(false)
    const [sentLoading, setSentLoading] = useState(false)
    const [selectedTransfer, setSelectedTransfer] = useState(null)
    const [openDetailModal, setOpenDetailModal] = useState(false)
    
    const getSentAccountTransfer = async() =>{
        setSentLoading(true)
        await accountServices.getSentAccountTransfer(hash_reservation).then((res)=>{
            setSentTransfer(res)
        }).finally(()=>{
            setSentLoading(false)
        })
    } 

    const ExchangeCard = ({currencies_exchange}) =>{
        const [openExchange, setOpenExchange] = useState(false)
        return(
            <div style={{display:'flex', flexDirection:'column', width:'100%'}}>
                <Visibility  
                    color={currencies_exchange ? 'primary':'disabled'} 
                    onClick={()=>{currencies_exchange && setOpenExchange(!openExchange)}} 
                    style={{cursor:currencies_exchange &&'pointer', alignSelf:'center'}}
                />
                <Dialog
                    open={openExchange}
                    onClose={()=>setOpenExchange(false)}
                >
                    <DialogTitle>
                        {translate('ra.title.exchange_types')}
                    </DialogTitle>
                    <DialogContent>
                        <div style={{display:'flex', flexDirection:'column'}}>
                            <div style={{borderWidth:'1px', marginBottom:'15px',borderColor:'black', borderStyle:'solid', display:'flex', flexDirection:'column', padding:'15px', borderRadius:'10px'/* , width:'50%' */}}>
                                {currencies_exchange?.map(cur=>(
                                    !cur.is_reverse && <label>
                                        {`${cur?.currency_relation?.short_name} - ${cur?.currency_to_relation?.short_name}: ${numberFormatterWithDecimalAndThousand(cur.value)}`}
                                    </label>
                                ))}
                            </div>
                            <Button 
                                variant='contained' 
                                style={{alignSelf:'flex-end', marginTop:'15px'}}
                                onClick={()=>{setOpenExchange(false)}}
                            >
                                {translate('ra.action.back')}
                            </Button>
                        </div>
                    </DialogContent>
                </Dialog>
            </div>
        )
    }

    const getReceivedAccountTransfer = async() =>{
        setReceivedLoading(true)
        await accountServices.getReceivedAccountTransfer(hash_reservation).then((res)=>{
            setReceivedTransfer(res)
        }).finally(()=>{
            setReceivedLoading(false)
        })
    } 

    useEffect(()=>{
        getSentAccountTransfer()
        getReceivedAccountTransfer()
    },[])

    const formatDate = (date) =>{
        if(date){
            const dateParts = date.split('-')
            return dateParts[2] + '/' + dateParts[1] + '/' + dateParts[0]
        }
        return ''
    }
  return (
    <>
    <Grid container spacing={1}>
        <Grid item xs={12} md={12} lg={6} xl={6}>
            <ShowCard
                title={translate('ra.title.balance_transfer_received')}
                preActionButtonJustify='flex-end'
                preActionButton={
                    <LoadingButton loading={receivedLoading} onClick={getReceivedAccountTransfer}>
                        <RefreshIcon />
                    </LoadingButton>
                }
            >
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>{translate('ra.field.origin')}</TableCell>
                                <TableCell>{translate('ra.field.currency')}</TableCell>
                                <TableCell>{translate('ra.field.amount')}</TableCell>
                                <TableCell>{translate('ra.action.actions')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {receivedLoading?[...Array(3)].map((_, i) => (
                            <TableCell key={i}>
                                <Skeleton variant='rectangular' width={'100%'} height={20} />
                            </TableCell>
                            )):
                            receivedTransfer.map(transfer=>(
                                <TableRow key={transfer.id}>
                                    <TableCell>{transfer.number}</TableCell>
                                    <TableCell>{transfer.currency_relation?.short_name}</TableCell>
                                    <TableCell>{numberFormatterWithDecimalAndThousand(transfer.amount)}</TableCell>
                                    <TableCell>
                                        <Visibility 
                                            fontSize='small' 
                                            color='info' 
                                            style={{cursor:'pointer'}}
                                            onClick={()=>{setSelectedTransfer({...transfer,isOrigin:false});setOpenDetailModal(true)}}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))
                            }
                        </TableBody>
                    </Table>
                </TableContainer>

            </ShowCard>
        </Grid>
        <Grid item xs={12} md={12} lg={6} xl={6}>
            <ShowCard
                title={translate('ra.title.balance_transfer_sent')}
                preActionButtonJustify='flex-end'
                preActionButton={
                    <LoadingButton loading={sentLoading} onClick={getSentAccountTransfer}>
                        <RefreshIcon />
                    </LoadingButton>
                }
            >
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>{translate('ra.field.destination')}</TableCell>
                                <TableCell>{translate('ra.field.currency')}</TableCell>
                                <TableCell>{translate('ra.field.amount')}</TableCell>
                                <TableCell>{translate('ra.action.actions')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            
                                {sentLoading?
                                <TableRow>
                                    {[...Array(3)].map((_, i) => (
                                        <TableCell key={i}>
                                            <Skeleton variant='rectangular' width={'100%'} height={20} />
                                        </TableCell>
                                    ))}
                                </TableRow>
                                :
                                sentTransfer.map(transfer=>(
                                    <TableRow key={transfer.id}>
                                        <TableCell>{transfer.number}</TableCell>
                                        <TableCell>{transfer.currency_relation?.short_name}</TableCell>
                                        <TableCell>{numberFormatterWithDecimalAndThousand(transfer.amount)}</TableCell>
                                        <TableCell>
                                            <Visibility 
                                                fontSize='small' 
                                                color='info' 
                                                style={{cursor:'pointer'}}
                                                onClick={()=>{setSelectedTransfer({...transfer,isOrigin:true}); setOpenDetailModal(true)}}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))
                                }
                        </TableBody>
                    </Table>
                </TableContainer>
            </ShowCard>
        </Grid>
        
    </Grid>
    <Dialog  fullWidth  maxWidth="lg" open={openDetailModal} onClose={() => { setOpenDetailModal(false) }}>
            {/* <DialogTitle>{translate('ra.title.credits_data')}</DialogTitle> */}
            <DialogContent >
                <div style={{display:'flex', flexDirection:'column'}}>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{translate('ra.field.id')}</TableCell>
                                    <TableCell>{translate('ra.field.origin')}</TableCell>
                                    <TableCell>{translate('ra.field.destination')}</TableCell>
                                    <TableCell>{translate('ra.field.date')}</TableCell>
                                    <TableCell>{translate('ra.field.amount')}</TableCell>
                                    <TableCell>{translate('ra.field.currency')}</TableCell>
                                    <TableCell>{translate('ra.title.exchange_type')}</TableCell>
                                    <TableCell>{translate('ra.title.exchange_types')}</TableCell>
                                    <TableCell>{translate('ra.field.description')}</TableCell>
                                    <TableCell>{translate('ra.field.client_code')}</TableCell>
                                    <TableCell>{translate('ra.field.created_at')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell>{selectedTransfer?.id}</TableCell>
                                    <TableCell>{selectedTransfer?.isOrigin ? currentNumber : selectedTransfer?.number}</TableCell>
                                    <TableCell>{selectedTransfer?.isOrigin ? selectedTransfer?.number : currentNumber}</TableCell>
                                    <TableCell>{formatDate(selectedTransfer?.date)}</TableCell>
                                    <TableCell>{numberFormatterWithDecimalAndThousand(selectedTransfer?.amount)}</TableCell>
                                    <TableCell>{selectedTransfer?.currency_relation?.short_name}</TableCell>
                                    <TableCell>{selectedTransfer?.currency_value}</TableCell>
                                    <TableCell>
                                        <ExchangeCard 
                                            currencies_exchange={selectedTransfer?.currencies_exchange}/
                                        >
                                    </TableCell>
                                    <TableCell>{selectedTransfer?.description}</TableCell>
                                    <TableCell>{selectedTransfer?.tma_code}</TableCell>
                                    <TableCell>{parseDateFormat(selectedTransfer?.created_at)}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Button 
                        variant='contained' 
                        style={{alignSelf:'flex-end', marginTop:'15px'}}
                        onClick={()=>{setOpenDetailModal(false)}}
                    >
                        {translate('ra.action.back')}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    </>
  )
}
